// extracted by mini-css-extract-plugin
export default {"paymentsItemsWrap":"styles_paymentsItemsWrap__r6Ghs","activePayment":"styles_activePayment__Xnt7v"};